"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const directedEdge_1 = require("../../lib/base/edges/directedEdge");
class SimpleDirectedEdge extends directedEdge_1.DirectedEdge {
    constructor() {
        super(...arguments);
        this.standardColor = "black";
        this.color = this.standardColor;
    }
    draw(ctx, grid) {
        ctx.strokeStyle = this.color;
        super.draw(ctx, grid);
    }
    setColor(color) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
    resetColor() {
        this.color = this.standardColor;
    }
}
exports.SimpleDirectedEdge = SimpleDirectedEdge;
